export const NO_DATA_DISPLAY = '-';
